import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export default class DisplayAdsAdvertisingUseCase extends UseCase {
  constructor({config, fromRawDataToAdvertisingValueObjectMapper, repository}) {
    super()

    this._fromRawDataToAdvertisingVOMapper = fromRawDataToAdvertisingValueObjectMapper
    this._repository = repository
    this._config = config
    this._defaultSearch = this._config.get('search').DEFAULT_SEARCH
  }

  @tracer({metric: 'DisplayAdsAdvertisingUseCase#execute'})
  @inlineError
  execute({pageName, search = this._defaultSearch, category, tag, searchTerm, section, ad, adType, seller}) {
    const advertisingVO = this._fromRawDataToAdvertisingVOMapper.map({
      pageName,
      search,
      category,
      tag,
      searchTerm,
      section,
      ad,
      adType,
      seller
    })
    const [error] = this._repository.displayAds(advertisingVO)

    if (error) {
      return Promise.reject(error)
    }
  }
}
